import { Icon } from "@phosphor-icons/react";
import {
  Chat,
  ChatTeardropDots,
  FolderOpen,
  Folders,
  SquaresFour,
  UsersThree,
  WhatsappLogo,
} from "@phosphor-icons/react";
import { ActionType } from "@tgc/types";
import { hasAction, isAdmin } from "../utils/helpers";

export type NavRoute = {
  path: string;
  pathName: string;
  icon: Icon;
  hide?: (user: any) => boolean;
  subRoutes?: {
    path: string;
    pathName: string;
    hide?: (campaign: any) => boolean;
  }[];
};

const routes: NavRoute[] = [
  {
    path: "/",
    pathName: "nav.home",
    icon: SquaresFour,
    subRoutes: [
      {
        hide: (campaign) => !hasAction(campaign, ActionType.GOOGLE_REVIEW),
        path: "/google",
        pathName: "nav.stats.google",
      },
      {
        hide: (campaign) => !hasAction(campaign, ActionType.INSTAGRAM),
        path: "/instagram",
        pathName: "nav.stats.instagram",
      },
      {
        hide: (campaign) => !hasAction(campaign, ActionType.TIKTOK),
        path: "/tiktok",
        pathName: "nav.stats.tiktok",
      },
      {
        hide: (campaign) => !hasAction(campaign, ActionType.FACEBOOK),
        path: "/facebook",
        pathName: "nav.stats.facebook",
      },
      {
        path: "/mail",
        pathName: "nav.stats.mail",
      },
      {
        hide: (campaign) => !hasAction(campaign, ActionType.REFERRAL),
        path: "/referral",
        pathName: "nav.stats.referral",
      },
    ],
  },
  {
    path: "/campaign",
    pathName: "nav.campaign.campaign",
    icon: FolderOpen,
  },
  {
    hide: (user) => !isAdmin(user),
    path: "/demo-campaigns",
    pathName: "nav.campaign.demo-campaigns",
    icon: Folders,
  },
  {
    path: "/sms-campaigns",
    pathName: "nav.campaign.sms-campaigns",
    icon: ChatTeardropDots,
  },
  {
    path: "/reviews-management",
    pathName: "nav.campaign.reviews-management",
    icon: Chat,
  },
  {
    path: "/users",
    pathName: "nav.users",
    icon: UsersThree,
  },
  {
    hide: (user) => !isAdmin(user),
    path: "/admin-players",
    pathName: "nav.adminPlayers",
    icon: UsersThree,
  },
  // {
  //   // TODO: decide when to hide it
  //   path: "/orders",
  //   pathName: "nav.orders.title",
  //   icon: WhatsappLogo,
  //   subRoutes: [
  //     {
  //       path: "/orders",
  //       pathName: "nav.orders.orders",
  //     },
  //     {
  //       path: "/orders/configs",
  //       pathName: "nav.orders.configuration",
  //     },
  //     {
  //       path: "/orders/chat",
  //       pathName: "nav.orders.chat",
  //     },
  //   ],
  // },
];

export default routes;
